import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSocket } from '../context/SocketContext';
import { useAuth } from '../context/AuthContext';

function IconWorkshops() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>;
}
function IconLog() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>;
}
function IconSettings() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>;
}

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { mqttConnected } = useSocket();
  const { operator, logout } = useAuth();

  const tabs = [
    { path: '/', label: 'Workshops', Icon: IconWorkshops },
    { path: '/log', label: 'Log', Icon: IconLog },
    { path: '/settings', label: 'Settings', Icon: IconSettings },
  ];

  const activeTab = location.pathname === '/' ? '/'
    : tabs.find(t => location.pathname.startsWith(t.path) && t.path !== '/')?.path || '/';

  return (
    <div className="app-layout">
      <header className="app-header">
        <div className="header-brand">
          <div className="header-logo">TAS</div>
          <div>
            <div className="header-title">Traverser Alert</div>
            <div className="header-subtitle">Workshop Control</div>
          </div>
        </div>

        <div className="header-right">
          {operator && (
            <div className={`operator-badge ${operator.toLowerCase()}`}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              {operator === 'T1' ? 'Traverser 1' : 'Traverser 2'}
            </div>
          )}
          <div className="mqtt-indicator">
            <div className={`mqtt-dot ${mqttConnected ? 'connected' : ''}`} />
            <span className="mqtt-label">{mqttConnected ? 'Live' : 'Offline'}</span>
          </div>
          <button className="logout-btn" onClick={logout} title="Logout">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            Logout
          </button>
        </div>
      </header>

      <main className="main-content">{children}</main>

      <nav className="bottom-nav">
        {tabs.map(({ path, label, Icon }) => (
          <button
            key={path}
            className={`nav-tab ${activeTab === path ? 'active' : ''}`}
            onClick={() => navigate(path)}
          >
            <Icon />
            <span>{label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}
